import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'at-avatar',
  standalone: true,
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[style.backgroundColor]': 'color()',
    'aria-hidden': 'true',
  },
})
export class AvatarComponent {
  public name = input.required<string>();

  protected initials = computed(() =>
    this.name()
      .split(' ')
      .map((n) => (n.length > 0 ? n[0] : ''))
      .filter((val, i, arr) => val !== ' ' && (i === 0 || i === arr.length - 1))
      .join('')
      .toUpperCase(),
  );

  /**
   * Generate a color based on the user name. It should have a minimum contrast of 10:1 with the text color
   * @returns {string} The color in hsl format
   */
  protected readonly color = computed<string>(() => {
    const hsl: number = this.getHslHueFromString(this.name());
    return `hsl(${hsl}, 90%, 94%)`;
  });

  private getHslHueFromString(value: string): number {
    const hash: number =
      value.split('').reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0) + value.length * 15;
    return hash % 360;
  }
}
